import { v4 as uuidv4 } from "uuid";
import actionTypes from "./_actions";
import * as _utils from "./_utils";

const _saveFeedSupplement = (offlineFarms, payload) => {
    const { farmId, budgetId, feedSupplement } = payload;

    if (!feedSupplement.id) feedSupplement.id = uuidv4();

    return offlineFarms.map((offlineFarm) => {
        if (offlineFarm.id !== farmId) return offlineFarm;

        return {
            ...offlineFarm,
            farm: {
                ...offlineFarm.farm,
                offlineBudgets: offlineFarm.farm.offlineBudgets.map((offlineBudget) => {
                    if (offlineBudget.id !== budgetId) return offlineBudget;

                    const feedSupplements = (offlineBudget.budget.feedSupplements || []).map((fs) => {
                        if (fs.id !== feedSupplement.id) return fs;

                        const originalAmounts = _utils.getAmounts(offlineBudget.budget, fs);
                        const newAmounts = _utils.getAmounts(offlineBudget.budget, feedSupplement);

                        const amountsReduced = originalAmounts.totalSourced > newAmounts.totalSourced;
                        const amountTypeChanged = fs.amountType !== feedSupplement.amountType;
                        const prevShowAutumnCuts = _utils.showAutumnCuts(offlineBudget.budget, fs);
                        const showAutumnCuts = _utils.showAutumnCuts(offlineBudget.budget, feedSupplement);
                        let destinations = feedSupplement.destinations || [];
                        // Reset distribution amounts if amount type changed or blocks have changed between lucerne and non-lucerne.
                        if (amountsReduced || amountTypeChanged || prevShowAutumnCuts !== showAutumnCuts) {
                            destinations = destinations.map((destination) => {
                                return {
                                    ...destination,
                                    amount: 0,
                                    amountAutumn: 0,
                                };
                            });
                        } else if (showAutumnCuts) {
                            // Reset distribution amounts if months have changed for harvested lucerne cuts.
                            const prevSources = fs.sources || [];
                            const sources = feedSupplement.sources || [];
                            const springSummerMonths = ["September", "October", "November", "December", "January", "February"];
                            const prevSpringSummerMonthCount = prevSources.filter((s) => !s.month || springSummerMonths.includes(s.month)).length;
                            const prevAutumnWinterMonthCount = prevSources.filter((s) => s.month && !springSummerMonths.includes(s.month)).length;
                            const springSummerMonthCount = sources.filter((s) => !s.month || springSummerMonths.includes(s.month)).length;
                            const autumnWinterMonthCount = sources.filter((s) => s.month && !springSummerMonths.includes(s.month)).length;
                            if (prevSpringSummerMonthCount !== springSummerMonthCount || prevAutumnWinterMonthCount !== autumnWinterMonthCount) {
                                destinations = destinations.map((destination) => {
                                    return {
                                        ...destination,
                                        amount: 0,
                                        amountAutumn: 0,
                                    };
                                });
                            }
                        }

                        return {
                            ...feedSupplement,
                            destinations,
                        };
                    });
                    if (!feedSupplements.some((fs) => fs.id === feedSupplement.id)) feedSupplements.push(feedSupplement);

                    return {
                        ...offlineBudget,
                        isDirty: true,
                        budget: {
                            ...offlineBudget.budget,
                            feedSupplements: feedSupplements,
                        },
                    };
                }),
            },
        };
    });
};

const _deleteFeedSupplement = (offlineFarms, payload) => {
    const { farmId, budgetId, id } = payload;

    return offlineFarms.map((offlineFarm) => {
        if (offlineFarm.id !== farmId) return offlineFarm;

        return {
            ...offlineFarm,
            farm: {
                ...offlineFarm.farm,
                offlineBudgets: offlineFarm.farm.offlineBudgets.map((offlineBudget) => {
                    if (offlineBudget.id !== budgetId) return offlineBudget;

                    const feedSupplements = (offlineBudget.budget.feedSupplements || []).filter((item) => item.id !== id);
                    return {
                        ...offlineBudget,
                        isDirty: true,
                        budget: {
                            ...offlineBudget.budget,
                            feedSupplements: feedSupplements,
                        },
                    };
                }),
            },
        };
    });
};

const reducer = (state = [], action) => {
    let offlineFarms = state;
    if (!Array.isArray(state)) {
        offlineFarms = Object.keys(state).map((item) => state[item]);
    }

    switch (action.type) {
        case actionTypes.FEED_SUPPLEMENT_SAVE:
            return _saveFeedSupplement(offlineFarms, action.payload);

        case actionTypes.FEED_SUPPLEMENT_DELETE:
            return _deleteFeedSupplement(offlineFarms, action.payload);

        default:
            return offlineFarms;
    }
};

export default reducer;
